module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "products"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._v("\n     vbvbvb " + _vm._s(_vm.products) + "bvbvbv\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-103c06dd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductList.vue
// module id = 248
// module chunks = 0